import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import ProvidersPage from "@/pages/ProvidersPage";
import SIMsPage from "@/pages/SIMsPage";
import DeviceModelsPage from "@/pages/DeviceModelsPage";
import DeviceDetailsPage from "@/pages/DeviceDetailsPage";
import InstallationTypesPage from "@/pages/InstallationTypesPage";
import EmployeesPage from "@/pages/EmployeesPage";
import VehiclesPage from "@/pages/VehiclesPage";
import SearchPage from "@/pages/SearchPage";
import UsersPage from "@/pages/UsersPage";
import ProfilePage from "@/pages/ProfilePage";
import RenewalRemindersPage from "@/pages/RenewalRemindersPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="masters/customers" element={<CustomersPage />} />
        <Route path="masters/providers" element={<ProvidersPage />} />
        <Route path="masters/sims" element={<SIMsPage />} />
        <Route path="masters/device-models" element={<DeviceModelsPage />} />
        <Route path="masters/device-details" element={<DeviceDetailsPage />} />
        <Route path="masters/installation-types" element={<InstallationTypesPage />} />
        <Route path="masters/employees" element={<EmployeesPage />} />
        <Route path="vehicles" element={<VehiclesPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="admin/users" element={<UsersPage />} />
        <Route path="admin/renewals" element={<RenewalRemindersPage />} />
        <Route path="profile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}
